<form [formGroup]="formDadosColaborador">
    <div class="card-content">
        <div class="card-holder --newBrand">
            <p class="card-holder-label" data-test="editLabelIdentificator">CPF:</p>
            <p class="card-holder-value"data-test="editValueIdentificator" >{{ infos?.identificator }}</p>
        </div>
        <div class="card-holder --newBrand">
            <p class="card-holder-label" data-test="editLabelBirthdate">Data de nascimento:</p>
            <p class="card-holder-value" data-test="editValueBirthdate">{{ infos?.birthdate | date: 'dd/MM/yyyy' }}</p>
        </div>
        <div class="card-holder --newBrand">
            <p class="card-holder-label" data-test="editLabelRole">Cargo:</p>
            <div class="card-holder-input">
                <div class="select --dark select-small">
                    <select name="role" formControlName="role" data-test="editSelectRole">
                        <ng-container *ngIf="roles$ | async as roles">
                            <option [value]="role.uid" *ngFor="let role of roles; let i = index" attr.data-test="editOptionRole{{i}}">{{ role.name }}</option>
                        </ng-container>
                    </select>
                </div>
            </div>
        </div>
        <div class="card-holder --newBrand">
            <p class="card-holder-label" data-test="editLabelDepartment">Departamento:</p>
            <div class="card-holder-input">
                <div class="select --dark select-small">
                    <select name="department" formControlName="department" data-test="editSelectDepartment">
                        <ng-container *ngIf="departments$ | async as departments;">
                            <option [value]="department.uid" *ngFor="let department of departments; let i = index" attr.data-test="editOptionDepartment{{i}}">{{ department.name }}</option>
                        </ng-container>
                    </select>
                </div>
            </div>
        </div>
        <div class="card-holder --newBrand">
            <p class="card-holder-label" data-test="editLabelFilial">Filial:</p>
            <div class="card-holder-input">
                <div class="select --dark select-small">
                    <select name="unit" formControlName="unit" data-test="editSelectUnit">
                        <ng-container *ngIf="units$ | async as units;">
                            <option [value]="unit.uid" *ngFor="let unit of units; let i = index" attr.data-test="editOptionUnit{{i}}">{{ unit.name }}</option>
                        </ng-container>
                    </select>
                </div>
            </div>
        </div>
        <div class="card-holder --newBrand">
            <p class="card-holder-label" data-test="editLabelRelation">Vínculo de contratação:</p>
            <p class="card-holder-value" data-test="editValueRelation">{{ infos?.admission?.relation || '--' }}</p>
        </div>
        <div class="card-holder --newBrand"  formGroupName="salary">
            <p class="card-holder-label" data-test="editLabelSalary">Salário:</p>
            <p class="card-holder-input">
                <input type="text" formControlName="value" data-test="editValueSalary" class="input-edit salary --dark" currencyMask [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',', allowNegative: false }">
            </p>
        </div>
    </div>
    <div class="card-footer">
        <button class="button-default button-link" type="button" (click)="cancel($event)" data-test="editCancelInfos">Cancelar</button>
        <button class="button-default button-confirm" (click)="submitForm(formDadosColaborador)" type="submit" data-test="editSaveInfos">Salvar</button>
    </div>
</form>
